// JsFromRoutes CacheKey d04b1fb4601661989bad5e10d79345da
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  createOrUpdate: /* #__PURE__ */ definePathHelper('post', '/admin/medical_plan_data_files/create_or_update'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/medical_plan_data_files'),
}
